'use client'
import { Box, Button, Typography } from '@mui/material';
import { useRouter } from 'next/navigation';
import { REPORT_TYPE } from "@/models/report";
import { useTranslations } from 'next-intl';

interface ReviewNoticeProps {
    isLogin?: boolean;
    reportType?: number;
    isPaymentEd?: boolean;
    slug?: string
    isShare?: boolean;
    isMobile?: boolean;
}

function ReviewNoticeShare({ isMobile, isLogin = false, reportType = REPORT_TYPE.FREE, isPaymentEd = false, slug, isShare }: ReviewNoticeProps) {
    const router = useRouter();
    const t = useTranslations("messages");
    // const isMobile = useDeviceDetect();

    const handleShareDetailClick = () => {
        // Simple approach - just add the from=share parameter
        window.location.href = `/report/${slug}`;
    };

    return isShare && (
        <Box
            className={`w-full p-[20px] sm:p-[24px] gap-[10px] flex-col border border-radius-[8px] bg-gray_2 absolute bottom-0 left-0 right-0 z-[11] overflow-y-auto mr-[51px] !hide-scrollbar
            }`}
        >
            <Box className="w-full p-[20px] sm:p-[24px] gap-[10px] flex-col border border-radius-[8px] bg-gray_5 h-auto min-h-[186px] max-w-full break-words">
                <Typography
                    variant="h6"
                    className="!mb-[10px] !text-ciBlue_900 !font-[Montserrat,sans-serif] !font-[600] !text-[22px] sm:!text-[24px] !leading-[24px] !tracking-[0px] whitespace-normal break-words text-left max-w-full"
                    translation-key={"report_subscribe_notice_share_title"}
                >
                    {t("report_subscribe_notice_share_title")}
                </Typography>
                <Typography
                    variant="body1"
                    className="!text-eerieBlack !font-[Montserrat,sans-serif] !font-[500] !text-[14px] sm:!text-[16px] !leading-[24px] !tracking-[0px] whitespace-normal break-words text-left max-w-full"
                    translation-key={"report_subscribe_notice_share_description"}
                >
                    {t("report_subscribe_notice_share_description")}
                </Typography>
                <Box className="flex my-[16px]">
                </Box>
                <Button className="min-h-[44px] max-h-[44px] w-auto !bg-ciBlue_900 !text-white !font-[Montserrat,sans-serif] !font-[500] !text-[16px] !leading-[24px] !tracking-[0px] !py-[4px] !px-[16px] !rounded-[4px] review-notice-share-button"
                    onClick={() => handleShareDetailClick()}>
                    <Typography className={'py-[4px]'} translation-key={"report_subscribe_notice_share_button"}>
                        {t("report_subscribe_notice_share_button")}
                    </Typography>
                </Button>
            </Box>
        </Box>
    );
}

export default ReviewNoticeShare;